var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.0002 3.83337C12.4317 3.83337 3.8335 12.4315 3.8335 23C3.8335 33.5685 12.4317 42.1667 23.0002 42.1667C33.5687 42.1667 42.1668 33.5685 42.1668 23C42.1668 12.4315 33.5687 3.83337 23.0002 3.83337ZM23.0002 38.3334C14.5457 38.3334 7.66683 31.4545 7.66683 23C7.66683 14.5456 14.5457 7.66671 23.0002 7.66671C31.4546 7.66671 38.3335 14.5456 38.3335 23C38.3335 31.4545 31.4546 38.3334 23.0002 38.3334Z","fill":"#85C3B3","key":0}),React.createElement("path",{"d":"M19.1645 26.0417L14.7581 21.643L12.0518 24.357L19.1683 31.4582L32.0215 18.6051L29.3113 15.8949L19.1645 26.0417Z","fill":"#85C3B3","key":1})]);
}

CheckCircle.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
